//common
import './common';

//components
// import './blocks/search'
import './blocks/filter'
import tooltip from './blocks/tooltip';
import Tab from './blocks/tab'
import ProductCarousel from './blocks/slider-product'
import RecipesCarousel from './blocks/slider-recipes'
import './blocks/pagination'


addEventListener('ajax:update-complete', () => {
    ProductCarousel.init();
    RecipesCarousel.init();
    Tab.initHandler();
    tooltip.init();
})